module.exports = __webpack_public_path__ + "static/08_co2_color_plot-b9c87bade43e7ddc51ce4ad08e4062c2.gif";